/* Tema Lienzo — JS sin dependencias */
(function () {
  'use strict';

  const routes = window.themeRoutes || {};
  const strings = window.themeStrings || {};
  const settings = window.themeSettings || {};
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const overlay = $('[data-overlay]');

  /* ---------- Utilidades ---------- */
  function formatMoney(cents, format) {
    const fmt = format || '{{amount_with_comma_separator}} €';
    const value = Number(cents) / 100;
    const group = (num, decimals, thousands, decimal) => {
      const fixed = num.toFixed(decimals);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        default: return group(value, 2, '.', ',');
      }
    });
  }

  function storage(action, key, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { /* almacenamiento no disponible */ }
    return null;
  }

  function showOverlay(show) {
    if (!overlay) return;
    overlay.hidden = !show;
    document.body.style.overflow = show ? 'hidden' : '';
  }

  /* ---------- Barra de anuncios ---------- */
  $$('[data-announcement-rotator]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    const interval = parseInt(bar.dataset.interval, 10) || 5000;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- Menú móvil ---------- */
  const menuDrawer = $('[data-menu-drawer]');
  function openMenu() {
    if (!menuDrawer) return;
    menuDrawer.hidden = false;
    document.body.classList.add('menu-is-open');
    showOverlay(true);
  }
  function closeMenu() {
    if (!menuDrawer || menuDrawer.hidden) return;
    menuDrawer.hidden = true;
    document.body.classList.remove('menu-is-open');
    showOverlay(false);
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) openMenu();
    if (e.target.closest('[data-menu-close]')) closeMenu();
  });

  /* ---------- Carrito ---------- */
  const drawer = $('[data-cart-drawer]');
  const useDrawer = settings.cartType === 'drawer' && !!drawer;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    showOverlay(true);
    drawer.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    showOverlay(false);
  }

  function sectionsToRender() {
    const ids = [];
    if (drawer) ids.push('cart-drawer');
    const page = $('[data-cart-page]');
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach((id) => {
      const html = sections[id];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newBody = $('[data-cart-body]', doc);
      let target = null;
      if (id === 'cart-drawer' && drawer) {
        target = $('[data-cart-body]', drawer);
        const newTitle = $('.cart-drawer__title', doc);
        const title = $('.cart-drawer__title', drawer);
        if (newTitle && title) title.innerHTML = newTitle.innerHTML;
      } else {
        const page = $(`[data-cart-page][data-section-id="${id}"]`);
        if (page) target = $('[data-cart-body]', page);
      }
      if (target && newBody) target.innerHTML = newBody.innerHTML;
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCount() {
    try {
      const res = await fetch(routes.cart, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      updateCount(cart.item_count);
    } catch (e) { /* sin conexión */ }
  }

  async function addToCart(items) {
    const res = await fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sectionsToRender(), sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || strings.cartError);
    if (!useDrawer) { window.location.href = routes.cart.replace(/\.js$/, ''); return; }
    renderSections(data.sections);
    await refreshCount();
    openDrawer();
  }

  async function changeLine(line, quantity) {
    const body = $$('[data-cart-body]');
    body.forEach((b) => b.classList.add('is-loading'));
    try {
      const res = await fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: sectionsToRender(), sections_url: window.location.pathname })
      });
      const cart = await res.json();
      renderSections(cart.sections);
      updateCount(cart.item_count);
    } catch (e) {
      window.location.reload();
    } finally {
      body.forEach((b) => b.classList.remove('is-loading'));
    }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && useDrawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    if (e.target.closest('[data-overlay]')) { closeDrawer(); closeMenu(); return; }

    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const item = qtyBtn.closest('[data-line]');
      const input = $('[data-qty-input]', item);
      const next = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.qtyChange, 10));
      input.value = next;
      changeLine(parseInt(item.dataset.line, 10), next);
      return;
    }
    const remove = e.target.closest('[data-remove-line]');
    if (remove) {
      e.preventDefault();
      changeLine(parseInt(remove.closest('[data-line]').dataset.line, 10), 0);
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (input) {
      const item = input.closest('[data-line]');
      changeLine(parseInt(item.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    }
    const sort = e.target.closest('[data-sort-select]');
    if (sort) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    if (e.target.matches('[data-auto-submit]')) e.target.form.submit();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); closePopup(); }
  });

  /* Botón «Añadir» de las tarjetas */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = $('button[type="submit"]', form);
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = strings.adding; }
    try {
      await addToCart([{ id: Number(form.elements.id.value), quantity: 1 }]);
    } catch (err) {
      window.alert(err.message);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  });

  /* ---------- Página de producto ---------- */
  $$('[data-product-section]').forEach((section) => {
    const moneyFormat = section.dataset.moneyFormat;
    const json = $('[data-product-json]', section);
    const product = json ? JSON.parse(json.textContent) : { variants: [] };
    let variant = product.variants.find((v) => v.id === product.currentVariant) || product.variants[0];

    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);
    const errorBox = $('[data-form-error]', section);
    const packs = $$('[data-pack]', section);

    function selectedPack() {
      const checked = packs.find((p) => p.checked);
      if (!checked) return { qty: 1, discount: 0, el: null };
      return { qty: parseInt(checked.dataset.qty, 10), discount: parseInt(checked.dataset.discount, 10), el: checked };
    }

    function refreshPacks() {
      if (!variant) return;
      packs.forEach((input) => {
        const label = input.closest('.pack');
        label.classList.toggle('is-selected', input.checked);
        const qty = parseInt(input.dataset.qty, 10);
        const discount = parseInt(input.dataset.discount, 10);
        const total = Math.floor((variant.price * qty * (100 - discount)) / 100);
        const each = Math.floor(total / qty);
        const eachEl = $('[data-pack-each]', label);
        const totalEl = $('[data-pack-total]', label);
        const wasEl = $('[data-pack-was]', label);
        if (eachEl) eachEl.textContent = formatMoney(each, moneyFormat).replace(/[.,]00(?=\D*$)/, '');
        if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
        if (wasEl) wasEl.textContent = formatMoney(variant.price, moneyFormat).replace(/[.,]00(?=\D*$)/, '');
      });
      refreshButton();
    }

    function refreshButton() {
      if (!addBtn || !variant) return;
      addBtn.disabled = !variant.available;
      if (!variant.available) { addLabel.textContent = strings.soldOut; return; }
      const pack = selectedPack();
      const total = Math.floor((variant.price * pack.qty * (100 - pack.discount)) / 100);
      addLabel.textContent = `${strings.addToCart} · ${formatMoney(total, moneyFormat)}`;
    }

    packs.forEach((p) => p.addEventListener('change', refreshPacks));

    const variantSelect = $('[data-variant-select]', section);
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        variant = product.variants.find((v) => String(v.id) === variantSelect.value) || variant;
        if (idInput) idInput.value = variant.id;
        const priceBox = $('[data-product-price] .price__current', section);
        if (priceBox) priceBox.textContent = formatMoney(variant.price, moneyFormat);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        refreshPacks();
      });
    }

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (errorBox) errorBox.hidden = true;
        const pack = selectedPack();
        const ids = [Number(idInput.value)];
        if (pack.el && pack.qty > 1) {
          const label = pack.el.closest('.pack');
          $$('[data-pack-extra]', label).forEach((sel) => ids.push(Number(sel.value)));
        }
        const merged = {};
        ids.forEach((id) => { merged[id] = (merged[id] || 0) + 1; });
        const items = Object.keys(merged).map((id) => ({ id: Number(id), quantity: merged[id] }));

        addBtn.disabled = true;
        addLabel.textContent = strings.adding;
        try {
          await addToCart(items);
        } catch (err) {
          if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
        } finally {
          refreshButton();
        }
      });
    }

    /* Galería: miniaturas y swipe */
    const slides = $('[data-gallery-slides]', section);
    const thumbs = $$('[data-thumb]', section);
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = parseInt(thumb.dataset.thumb, 10);
        slides.scrollTo({ left: slides.clientWidth * index, behavior: 'smooth' });
      });
    });
    if (slides && thumbs.length) {
      let raf;
      slides.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const index = Math.round(slides.scrollLeft / slides.clientWidth);
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
        });
      });
    }

    refreshPacks();
  });

  /* ---------- Recomendaciones ---------- */
  $$('[data-recommendations]').forEach(async (box) => {
    if (!box.dataset.url || box.children.length) return;
    try {
      const res = await fetch(box.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
      else box.hidden = true;
    } catch (e) { box.hidden = true; }
  });

  /* ---------- Popup de descuento ---------- */
  const popup = $('[data-popup]');
  const popupTab = $('[data-popup-open]');
  const POPUP_KEY = 'lienzo_popup_closed';

  function openPopup() { if (popup) { popup.hidden = false; if (popupTab) popupTab.hidden = true; } }
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    storage('set', POPUP_KEY, '1');
    if (popupTab) popupTab.hidden = false;
  }

  if (popup) {
    if ($('[data-popup-success]', popup)) {
      openPopup();
    } else if (!storage('get', POPUP_KEY)) {
      setTimeout(openPopup, parseInt(popup.dataset.delay, 10) || 8000);
    } else if (popupTab) {
      popupTab.hidden = false;
    }
    popup.addEventListener('click', (e) => {
      if (e.target === popup || e.target.closest('[data-popup-close]')) closePopup();
    });
    if (popupTab) popupTab.addEventListener('click', openPopup);
  }

  /* Editor de temas: abrir el carrito o el popup al seleccionar su sección */
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('[data-popup]')) openPopup();
  });
})();
